module.exports = __webpack_public_path__ + "static/sso-duo-f8f1ad721a3b33ed2681af4da7e38b74.jpg";